import { render, staticRenderFns } from "./ArtikelTypeComponent.vue?vue&type=template&id=03468b90&"
import script from "./ArtikelTypeComponent.vue?vue&type=script&lang=js&"
export * from "./ArtikelTypeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports